import {ErrorMessage, Field} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import remote_icon from '../../../../../../../../../assets/job_postings/icons/remote-icon.png';
import {
  EmpionSelectField,
  EmpionSelectFieldOption,
} from '../../../../../../../../../components/EmpionSelectField/EmpionSelectField';

interface HardFactsFieldsWorkModeProps {
  options: EmpionSelectFieldOption[];
}

export const HardFactsFieldsWorkMode = ({options}: HardFactsFieldsWorkModeProps) => {
  const {t} = useTranslation();

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box width={'100%'} display={'flex'} alignItems={'center'} gap={'8px'}>
        <Box component='img' src={remote_icon} alt='remote_icon' />
        <Field
          type='select'
          name='workMode'
          label={`${t('companyJobPostings.newJobDialog.formLabels.workMode')}`}
          component={EmpionSelectField}
          options={options}
          size={'small'}
          fullWidth
          required={true}
        />
      </Box>
      <Box ml={3}>
        <Typography variant='body2' color='error'>
          <ErrorMessage name='workMode' component='span' />
        </Typography>
      </Box>
    </Grid>
  );
};
